import { Label } from "../UI/label";
import { useCurrency } from "../../Hooks/useCurrency";
import React from "react";

const BusinessInput = React.forwardRef(
  (
    {
      fieldID,
      label,
      placeholder,
      value,
      onChange,
      required = false,
      maxDecimalPlaces = 2,
      maxIntegerDigits = 18,
      className = "space-y-1.5",
      disabled = false,
      onBlur,
    },
    ref
  ) => {
    const currencySymbol = useCurrency();

    const handleInputChange = (e) => {
      const val = e.target.value;
      // Create dynamic regex based on props
      const regex = new RegExp(
        `^\\d{0,${maxIntegerDigits}}(\\.\\d{0,${maxDecimalPlaces}})?$`
      );
      if (regex.test(val) || val === "") {
        onChange(e);
      }
    };

    const showYearSuffix = fieldID === "businessPotential";

    return (
      <div key={fieldID} className={className}>
        {label && (
          <Label htmlFor={fieldID} required={required}>
            {label}
          </Label>
        )}
        <div className="flex items-center gap-2">
          <div
            ref={ref} // Attach ref to the outer div
            tabIndex={0} // Make the div focusable
            className={`sahi-input flex w-full shadow-xs h-11 sahi-radius overflow-hidden ${
              disabled ? "opacity-50 cursor-not-allowed" : ""
            } ${!disabled ? "focus:ring-2 focus:ring-blue-500 focus:outline-none" : ""}`} // Focus styling
            onFocus={(e) => e.currentTarget.querySelector("input").focus()} // Delegate focus to input on div focus
          >
            <span
              className="h-11 w-10 flex items-center justify-center px-3 bg-background border-r border-gray-300 shrink-0"
              aria-hidden="true"
            >
              {currencySymbol}
            </span>
            <input
              id={fieldID}
              name={fieldID}
              value={value}
              onChange={handleInputChange}
              onBlur={onBlur}
              placeholder={placeholder}
              disabled={disabled}
              className="flex-1 border-0 focus:ring-0 focus:outline-none bg-transparent px-3 h-full placeholder:text-muted-foreground text-sm min-w-0 disabled:cursor-not-allowed"
              type="text"
              maxLength="18"
              autoComplete="off"
              inputMode="decimal"
            />
          </div>
          {showYearSuffix && (
            <span className="text-sm text-black-500 whitespace-nowrap flex-shrink-0">
              / yr
            </span>
          )}
        </div>
      </div>
    );
  }
);

BusinessInput.displayName = "BusinessInput";
export default BusinessInput;